import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Card, CardContent, Alert, CircularProgress, TextField, Tooltip, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

import { snakeToTitleCase } from './JsonTable';

export const API_BASE_URL = "https://api.braidapp.ai"  // backend ngrok url 

export const OAuthButton = ({ company, type, disabled, rawTokenSubmit = false }) => {
    const [status, setStatus] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [rawToken, setRawToken] = useState('');

    const checkOAuthStatus = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/oauth/status/${type}?company=${company}`);
            const data = await response.json();
            if (data.connected) {
                setStatus(`Connected to ${snakeToTitleCase(type)}!`);
            }
            setLoading(false);
        } catch (error) {
            console.error(error);
            setError('Failed to check OAuth status.');
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!disabled) {
            checkOAuthStatus();
        }
    }, []);

    const handleOAuth = async () => {
        setStatus('');
        setError('');
        setLoading(true);
        try {
            window.location.replace(`${API_BASE_URL}/oauth?company=${company}&type=${type}`);
        } catch (error) {
            console.error(error);
            setError('Failed to redirect to Backend.');
            setLoading(false);
        }
    };

    const handleSubmitRawToken = async (event) => {
        event.preventDefault(); // Prevent page refresh
        try {
            const response = await fetch(`${API_BASE_URL}/oauth/submit-token`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    tokens: {
                        access_token: rawToken,
                        token_type: "bearer",
                        scope: "pat"
                    },
                    company: company,
                    type: type
                }),
            });
            const data = await response.json();
            if (response.ok) {
                setStatus(data.message);
            }
        } catch (error) {
            console.error(error);
            setError('Failed to submit token.');
        }
    };

    if (disabled) {
        return (
            <>
                <Button
                    variant="contained"
                    disabled
                >
                    Connect with OAuth
                </Button>
                <Alert severity="warning">This integration is currently disabled.</Alert>
            </>
        );
    } else if (loading) {
        return (
            <CircularProgress />
        );
    } else {
        return (
            <Box>
                <Button
                    onClick={handleOAuth}
                    variant="contained"
                >
                    Connect with OAuth
                </Button>
                {
                    rawTokenSubmit && (
                        <Box
                            component="form"
                            onSubmit={handleSubmitRawToken}
                            noValidate
                            sx={{ mt: 2, width: '100%', margin: '0 auto' }}
                        >
                            <TextField
                                label="PAT (Personal Access Token)"
                                type="password"
                                variant="outlined"
                                required
                                fullWidth
                                value={rawToken}
                                onChange={(e) => setRawToken(e.target.value)}
                                margin="normal"
                            />
                            <Tooltip title={
                                <Box sx={{ fontSize: 15 }}> {/* Adjust maxWidth as needed */}
                                    <ol>
                                        <li><a href="https://github.com/settings/personal-access-tokens/new" target="_blank" rel="noopener noreferrer">Go to THIS link (Github settings).</a></li>
                                        <li>Click "Generate new token".</li>
                                        <li>Enter Name, Expiration</li>
                                        <li>Select All Repositories or Only Select Repositories</li>
                                        <li>Under Repository Permissions, add Read-Only access to Commit Statuses, Content, Issues, Pulls</li>
                                        <li>Generate Token and paste it here then submit.</li>
                                    </ol>
                                </Box>
                            }>
                                <IconButton>
                                    <InfoIcon />
                                </IconButton>
                            </Tooltip>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                            >
                                Submit
                            </Button>
                        </Box>
                    )
                }
                {status && (
                    <Alert severity="success">{status}</Alert>
                )}
                {error && (
                    <Alert severity="error">{error}</Alert>
                )}
            </Box>
        );
    }
};